import styled from '@emotion/styled';
import { css, IconButton } from '@mui/material';
import { Grid } from '@mui/system';
import { ESizeModalThumbnail } from 'models/galery';
import { colors } from 'theme/colors';

const CustomModalRoot = styled('div')`
  position: fixed;
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
`;

const ModalContent = styled('div')(`
  height: calc(100vh - 42px);
  width: calc(100vw - 42px);
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  overflow: hidden;
  background-color: ${colors.white};
  border-radius: 3.5px;
  border: 1px solid ${colors.primary500};
  padding: 0px;
  margin: auto;
  box-shadow: 0px 7px 14px 0px #053A6812, 0px 7px 7px 0px #053A6826;
`);

const ModalControlTopContent = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 80px;
  padding: 20px;

  button {
    padding: 0;
    width: 40px;
    height: 40px;
    background: ${colors.white};
    border: 1px solid ${colors.primary500};
    border-radius: 4px;
    & svg {
      color: ${colors.primary500};
    }
  }
`;

const ModalImageContent = styled('div')`
  display: grid;
  justify-content: center;
  align-items: center;
  max-height: calc(100vh - 83px);
  height: 100%;

  flex: 1;
  overflow: hidden;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;
const ModalThumbnailsContainer = styled('div')`
  display: flex;
  width: auto;
  justify-content: flex-start !important;
  align-items: flex-end;
  justify-content: center;
  align-items: center;
  height: calc(${ESizeModalThumbnail.HEIGHT}px + 10px);
  margin-top: 10px;
  padding: 0 5px;
  overflow-x: auto;
  gap: 20px;
  overflow-y: hidden;
  ::-webkit-scrollbar {
    margin-top: 5px;
    height: 5px;
    background: #dfdfe2;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #aaaaaf;
  }
`;

const ModalThumbnailsSubContainer = styled('div')`
  display: flex;
  margin: auto;
  gap: 20px;
`;

const ModalimageThumbnailsContainer = styled('div')`
  min-width: ${ESizeModalThumbnail.WIDTH}px;
  width: ${ESizeModalThumbnail.WIDTH}px;
  height: ${ESizeModalThumbnail.HEIGHT}px;
  aspect-ratio: ${`${ESizeModalThumbnail.WIDTH} / ${ESizeModalThumbnail.HEIGHT}`};

  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  cursor: pointer;
`;

interface IModalimageThumbnails {
  selected: boolean;
}

const ModalimageThumbnails = styled.div<IModalimageThumbnails>`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  border-radius: 4px;
  ${(props: IModalimageThumbnails) => css`
    border: 1px solid ${props.selected ? colors.primary600 : colors.primary25};
  `}

  > img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

interface IStyledModalImage {
  zoom: string | number;
  x: string | number;
  y: string | number;
}

const ModalImage = styled.div<IStyledModalImage>`
  width: 100%;
  height: auto;
  max-height: calc(100vh - (${ESizeModalThumbnail.HEIGHT}px + 20px + 42px + 160px));
  width: auto;
  display: flex;
  justify-content: center;
  align-content: center;
  img {
    width: 100%;
    object-fit: contain;

    ${(props: IStyledModalImage) => css`
      transform: translate(${props.x}px, ${props.y}px) scale(${props.zoom});
    `}
    transform-origin: center center;
    transition: transform 0.15s ease;

    user-select: none;
    pointer-events: none;
  }
`;

const ModalControlContent = styled('div')`
  display: flex;
  height: 80px;
  padding: 20px;
  justify-content: space-between;
  align-items: center;
  width: inherit;
  z-index: 9;
`;

const ModalControlButton = styled(IconButton)`
  width: 40px;
  height: 40px;
  border: 1px solid ${colors.primary500};
  border-radius: 4px;
`;

export {
  CustomModalRoot,
  ModalContent,
  ModalControlButton,
  ModalControlContent,
  ModalControlTopContent,
  ModalImage,
  ModalImageContent,
  ModalThumbnailsContainer,
  ModalThumbnailsSubContainer,
  ModalimageThumbnailsContainer,
  ModalimageThumbnails,
};
